"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerUISendFeedbackValidation = void 0;
class ChargerUISendFeedbackValidation {
    static isValid(entity) {
        // Validate entity.feedback_charger_ui_interface_FeedbackProvided_json for existence and correct type.
        if (entity.feedback_charger_ui_interface_FeedbackProvided_json == undefined)
            return false;
        if (typeof entity.feedback_charger_ui_interface_FeedbackProvided_json !==
            "string")
            return false;
        return true;
    }
}
exports.ChargerUISendFeedbackValidation = ChargerUISendFeedbackValidation;
